//@ts-ignore
import React, { FC } from 'react';
import { FullscreenButtonStyled } from './styled';
import { ButtonProps } from './types';

const FullscreenButton: FC<ButtonProps & { children?: any }> = ({ onClick, isFullscreen }) => (
  <FullscreenButtonStyled onClick={onClick} isFullscreen={isFullscreen}>
    <i className={isFullscreen ? 'fas fa-compress' : 'fas fa-expand'} />
  </FullscreenButtonStyled>
);

export default FullscreenButton;
